var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"proposals-form"},[_c('embed-frame',{staticClass:"proposals-form-frame",attrs:{"endpoint":"proposals/form","placeholder":"Carregando...","settings":_vm.embedSettings,"callbacks":_vm.embedCallbacks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }